import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Loader } from '../Loader/Loader';
import { EmptyContainer, Empty } from './LoadingDeliveryTable.styled';

export const LoadingDeliveryTable = ({ loading }) => {
  const { t } = useTranslation();

  return (
    <TableRow hover tabIndex={-1}>
      <TableCell id={1} scope="row" colSpan={10}>
        <EmptyContainer>
          {loading ? <Loader /> : null}
          <Empty>
            {loading ? t('Delivery.table.loading') : t('Delivery.table.empty')}
          </Empty>
        </EmptyContainer>
      </TableCell>
    </TableRow>
  );
};

LoadingDeliveryTable.propTypes = {
  loading: PropTypes.bool,
};
